import { Checkbox } from '@material-ui/core';
import * as React from 'react';
import Portal from '../../utils/Portal';
import "src/js/common/polyfill/closest";

export function Checkboxs(props: { selected, setSelected, gridRef }) {
	const gridRef = props.gridRef;
	const selected = props.selected;
	const setSelected = props.setSelected;

	let checkboxs: JSX.Element[] = [];
	if (gridRef.current) {
		let nodes = gridRef.current.getElementsByClassName("react-checkbox-portal-container");
		checkboxs = Array.from(nodes).map((node: HTMLElement) => {
			let key = node.dataset.key;
			return (<CheckBoxPortal
				key={node.id}
				id={node.id}
				gridKey={key}
				selected={selected[key] ?? false}
				onChange={(v) => {
					let copy = { ...selected };
					copy[key] = v;
					setSelected(copy);
				}}
			/>);
		});
	}

	return <>
		{checkboxs}
	</>;
}

interface ICheckBoxPortalProps {
	id: string,
	selected: boolean,
	onChange: (selected: boolean) => void,
	gridKey: string,
}

function CheckBoxPortal(props: ICheckBoxPortalProps) {

	const row = React.useRef<HTMLTableRowElement>();

	React.useEffect(() => {
		row.current = document.getElementById(props.id).closest("tr");
		if (props.selected)
			selectRow(row.current);
		else
			unselectRow(row.current);
	}, []);

	function selectRow(row: HTMLElement) {
		row.classList.add('row_selected');
	}

	function unselectRow(row: HTMLElement) {
		row.classList.remove('row_selected');
	}

	function handleChange(v: boolean) {
		if (v)
			selectRow(row.current);
		else
			unselectRow(row.current);

		props.onChange(v);
	}

	return <Portal id={props.id}>
		<Checkbox
			checked={props.selected}
			onChange={(e) => handleChange(e.target.checked)}
			color="primary"
		/>
	</Portal>
};